export default __webpack_public_path__ + "static/media/il.dd611650.svg";